export default function LocaleSelect() {
  return null;
}
